import { useEffect, useState } from 'react';
import { Api } from '../../services/api';
import { useLanguage } from '../../context/LanguageContext';

const normalizeFaqs = (payload) => {
  const list = Array.isArray(payload)
    ? payload
    : Array.isArray(payload?.data)
    ? payload.data
    : [];
  return list.map((entry, index) => ({
    id: entry.id || index,
    question: entry.question || entry.q || 'Question',
    answer: entry.answer || entry.a || 'Answer',
  }));
};

const FaqPage = () => {
  const [faqs, setFaqs] = useState([]);
  const [openId, setOpenId] = useState(null);
  const [loading, setLoading] = useState(true);
  const activeFaq = faqs.find((entry) => entry.id === openId) || faqs[0];
  const { t } = useLanguage();

  useEffect(() => {
    let cancelled = false;
    const loadFaqs = async () => {
      setLoading(true);
      try {
        const response = await Api.fetchFaqs();
        if (cancelled) return;
        const list = normalizeFaqs(response?.data?.data || response?.data || response);
        setFaqs(list);
        setOpenId(list[0]?.id ?? null);
      } catch {
        if (!cancelled) {
          setFaqs([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };
    loadFaqs();
    return () => {
      cancelled = true;
    };
  }, []);

  const toggle = (id) => {
    setOpenId((current) => (current === id ? null : id));
  };

  return (
    <div className="faq-page">
      <header className="faq-page__header">
        <h1>{t('faq.title')}</h1>
        <p>{t('faq.description')}</p>
      </header>
      <div className="faq-layout">
        <div className="faq-list">
          {loading && !faqs.length ? (
            <p className="faq-loading">{t('faq.loading')}</p>
          ) : !faqs.length ? (
            <p className="faq-empty">{t('faq.empty')}</p>
          ) : (
            faqs.map((entry) => (
              <article
                key={entry.id}
                className={`faq-item ${openId === entry.id ? 'is-open' : ''}`}
              >
                <button
                  type="button"
                  className="faq-question"
                  onClick={() => toggle(entry.id)}
                >
                  <span>{entry.question}</span>
                  <span className="faq-icon">
                    {openId === entry.id ? '−' : '>'}
                  </span>
                </button>
              </article>
            ))
          )}
        </div>
        <div className="faq-answer-panel">
          {activeFaq ? (
            <>
              <h3>{activeFaq.question}</h3>
              <p>{activeFaq.answer}</p>
            </>
          ) : (
            <p className="faq-empty">{t('faq.select_prompt')}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default FaqPage;
